import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as courseSummaryActions } from '../../../../../domain/useCases/courses/getSummaryCourses';
import { Creators as coursePeriodActions } from '../../../../../domain/useCases/courses/getPeriodCourses';
import MyCoursesView from './MyCoursesView';
import XCheckpointManager from '@/core/managers/xcheckpointManager';
import constants from '../../constants';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const MyCoursesViewController = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [selectPeriod, setSelectPeriod] = useState({ value: '', name: '' });
  const [reversedMyPeriodCourse, setReversedMyPeriodCourse] = useState<any>([]);
  const [xcheckExecuted, setXcheckExecuted] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const { data: myPeriodCourse, isLoading: isLoadingPeriod } = useSelector(
    (state: any) => state.getPeriodCourses
  );
  const { data: mySummaryCourse, isLoading: isLoadingSummary } = useSelector(
    (state: any) => state.getSummaryCourses
  );

  useEffect(() => {
    GoogleAnalytics.writeLog('portal-course-myCourses', 'course');
    XCheckpointManager.registerStart('Mis cursos');
    if (!myPeriodCourse) dispatch(coursePeriodActions.getCoursePeriod());

    const handleOnlineStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', handleOnlineStatusChange);
    window.addEventListener('offline', handleOnlineStatusChange);

    // Limpia los event listeners al desmontar el componente
    return () => {
      window.removeEventListener('online', handleOnlineStatusChange);
      window.removeEventListener('offline', handleOnlineStatusChange);
      dispatch(courseSummaryActions.getCourseSummaryClear());
    };
  }, []);

  const handlePeriod = async (e: any) => {
    setSelectPeriod(e);
    dispatch(courseSummaryActions.getCourseSummary(e.value.toString()));
  };

  useEffect(() => {
    if (myPeriodCourse) {
      setReversedMyPeriodCourse([...myPeriodCourse].reverse());
      const lastElement = myPeriodCourse[myPeriodCourse.length - 1];
      const value = lastElement?.id;
      handlePeriod({ value, name: lastElement?.name });
    }
  }, [myPeriodCourse]);

  useEffect(() => {
    if (myPeriodCourse && mySummaryCourse && !xcheckExecuted) {
      XCheckpointManager.registerEnd('Mis cursos');
      setXcheckExecuted(true);
    }
  }, [myPeriodCourse, mySummaryCourse]);

  const handlerBack = () => history.push('/cursos');

  return (
    <MyCoursesView
      isOnline={isOnline}
      selectPeriod={selectPeriod}
      handlePeriod={handlePeriod}
      handlerBack={handlerBack}
      myPeriodCourse={reversedMyPeriodCourse?.map((item: any) => ({
        value: item.id,
        name: item.name
      }))}
      mySummaryCourse={mySummaryCourse}
      isLoadingPeriod={isLoadingPeriod}
      isLoadingSummary={isLoadingSummary}
      subsectionHeader={constants.subsectionHeader}
    />
  );
};

export default MyCoursesViewController;
